import { NODE_ENV } from '@config/constants';
import { persistState as persistOrganizationsState } from '@redux/persistors/organization';
import { persistState as persistTasksState } from '@redux/persistors/tasks';
import { rootReducer } from '@redux/reducers';
import { configureStore } from '@reduxjs/toolkit';

const DEV_MODE = NODE_ENV === 'development';

const store = configureStore({
  devTools: DEV_MODE,
  reducer: rootReducer
});

store.subscribe(() => {
  const state = store.getState();
  persistTasksState(state.tasks);
  persistOrganizationsState(state.organizations);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
